import { render } from "./MainPointChartField.vue?vue&type=template&id=6715d354&scoped=true"
import script from "./MainPointChartField.vue?vue&type=script&lang=js"
export * from "./MainPointChartField.vue?vue&type=script&lang=js"

import "./MainPointChartField.vue?vue&type=style&index=0&id=6715d354&scoped=true&lang=css"

import exportComponent from "/var/www/pointra/manager/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6715d354"],['__file',"MainPointChartField.vue"]])

export default __exports__